import React, { FC } from 'react'

// Components
import { Row, ContentCell } from '../PlanOverviewPanel/PlanOverviewPanel.styles'
import RowGroup from '../RowGroup'

// Utils
import { formatPriceShort } from 'utils/money'

// Types
import { BillingSeatsInfoFragment, useDraftBillingSummaryQuery } from 'gqlTypes'

interface ProjectedTotalProps {
  seats: BillingSeatsInfoFragment
  projectedCost?: number
  hasSubscription?: boolean
}

const ProjectedTotal: FC<ProjectedTotalProps> = ({
  projectedCost,
  hasSubscription,
  seats,
}) => {
  const { data: draftBillingSummaryYearlyData } = useDraftBillingSummaryQuery({
    variables: {
      planId: 'sketch_yearly',
      seats: seats.currentSeatsTotal,
    },
    skip: hasSubscription,
  })
  const { data: draftBillingSummaryMonthlyData } = useDraftBillingSummaryQuery({
    variables: {
      planId: 'sketch_monthly',
      seats: seats.currentSeatsTotal,
    },
    skip: hasSubscription,
  })

  return (
    <Row>
      <RowGroup.HeadingCell width={['70%', 1 / 4]}>
        Projected Total
      </RowGroup.HeadingCell>
      <ContentCell>
        <div>
          {hasSubscription ? (
            <b data-testId="projected-total-amount">
              {formatPriceShort(projectedCost)}
            </b>
          ) : (
            <span data-testId="draft-amount">
              <b>
                {formatPriceShort(
                  draftBillingSummaryYearlyData?.draftBillingSummary
                    .billingCycleAmount
                )}
              </b>{' '}
              yearly or{' '}
              <b>
                {formatPriceShort(
                  draftBillingSummaryMonthlyData?.draftBillingSummary
                    .billingCycleAmount
                )}
              </b>{' '}
              monthly
            </span>
          )}
          <br />
          {hasSubscription
            ? 'Total excluding tax'
            : 'With a paid subscription you would be charged for the total number of Editor Seats you’re using. Total excluding tax.'}
        </div>
      </ContentCell>
    </Row>
  )
}

export default ProjectedTotal
